import PropTypes from "prop-types"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { getSalonSlug } from "../../utils/salonHost"
import { resolveCompanyFromHost } from "../../store/companySlice"
import localStorageService from "../../services/localStorage.service"
import PageLoadingShell from "../ui/pageLoadingShell"
import NotFoundPage from "../../pages/notFoundPage"

const SALON_SCOPED_PREFIXES = ["/client", "/crm", "/admin"]

const isSalonScopedRoute = (pathname) =>
  SALON_SCOPED_PREFIXES.some((prefix) => pathname.startsWith(prefix))

const CompanyBootstrap = ({ children }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const hostSlug = getSalonSlug()
  const { status, id: hostCompanyId } = useSelector((state) => state.company)
  const pathname = location.pathname
  const clientRoute = pathname.startsWith("/client")
  const scopedSalonRoute = Boolean(hostSlug) && isSalonScopedRoute(pathname)

  useEffect(() => {
    if (hostSlug) {
      dispatch(resolveCompanyFromHost())
    }
  }, [dispatch, hostSlug])

  useEffect(() => {
    if (!hostSlug || hostCompanyId == null) return
    localStorageService.setAdminCompanyId(hostCompanyId)
  }, [hostSlug, hostCompanyId])

  if (scopedSalonRoute && clientRoute && (status === "idle" || status === "loading")) {
    return <PageLoadingShell />
  }

  if (scopedSalonRoute && clientRoute && status === "error") {
    return <NotFoundPage />
  }

  return children
}

CompanyBootstrap.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

export default CompanyBootstrap
